export default "__VITE_ASSET__CJttmyJP__"